import React, { createContext, useContext, useState, useEffect } from "react";
import { TRANSLATIONS } from "./translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("bd_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("bd_lang", lang);
  }, [lang]);

  const t = (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key;
  const toggle = () => setLang((l) => (l === "en" ? "fr" : "en"));

  return (
    <I18nContext.Provider value={{ lang, setLang, t, toggle }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
